import { InsertChart } from '@mui/icons-material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import BoyIcon from '@mui/icons-material/Face';
import GirlIcon from '@mui/icons-material/Face3';
import {
  Box,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from '@mui/material';
import { getClassFromFirstYear } from '../../helpers/academic-years';
import { Gender, Student } from '../../types/student';

interface ClassWithStudents {
  classYear: number;
  students: Student[];
}

interface StudentListProps {
  students: Student[];
  onRating: (student: Student) => void;
  onEdit: (student: Student) => void;
  onDelete: (student: Student) => void;
}

const StudentList: React.FC<StudentListProps> = ({
  students,
  onRating,
  onEdit,
  onDelete,
}) => {
  const getClassesWithStudents = (): ClassWithStudents[] => {
    const classesWithStudents: ClassWithStudents[] = [];

    students.forEach((student) => {
      const classYear = getClassFromFirstYear(student.firstYear);
      if (classYear > 9 || classYear <= 0) return;

      const existingClass = classesWithStudents.find(
        (classWithStudents) => classWithStudents.classYear === classYear
      );

      if (existingClass) {
        existingClass.students.push(student);
      } else {
        classesWithStudents.push({ classYear, students: [student] });
      }
    });

    return classesWithStudents;
  };

  const classesWithStudents = getClassesWithStudents();

  return classesWithStudents.map(({ classYear, students }) => (
    <Box key={classYear} mt={2}>
      <Typography variant="h6" noWrap>
        {`${classYear}. třída`}
      </Typography>
      <TableContainer component={Paper}>
        <Table>
          <TableBody>
            {students.map((student) => (
              <TableRow key={student.id} className="HoverRow">
                <TableCell sx={{ px: 2, py: 1.5 }}>
                  <Box display="flex" alignItems="center" gap={2}>
                    {student.gender === Gender.Male ? (
                      <BoyIcon />
                    ) : (
                      <GirlIcon />
                    )}
                    {student.name}
                  </Box>
                </TableCell>
                <TableCell className="RowButtonCell" align="right">
                  <Box>
                    <Box width={16} />
                    <IconButton
                      onClick={(event) => {
                        event.stopPropagation();
                        return onRating(student);
                      }}
                    >
                      <InsertChart />
                    </IconButton>
                    <Box width={8} />
                    <IconButton
                      onClick={(event) => {
                        event.stopPropagation();
                        return onEdit(student);
                      }}
                    >
                      <EditIcon />
                    </IconButton>
                    <Box width={8} />
                    <IconButton
                      onClick={(event) => {
                        event.stopPropagation();
                        return onDelete(student);
                      }}
                    >
                      <DeleteIcon />
                    </IconButton>
                    <Box width={16} />
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  ));
};

export default StudentList;
